import { NormalizedScheduledLeg } from '@mopla/data-models';

import { EntityDescriptor } from '../business-logic';
import { scheduleDiffSchema } from '../schemas/scheduleDiffSchema';

export enum ScheduleDiffTypes {
	'NEW' = 'NEW',
	'NEW_BREAK' = 'NEW_BREAK',
	'DELETED' = 'DELETED',
	'DELAYED' = 'DELAYED',
	'DELAYED_BREAK' = 'DELAYED_BREAK',
}

export type ScheduleDiffEl = NormalizedScheduledLeg & {
	updateState: ScheduleDiffTypes;
};

export const scheduleDiffEntity: EntityDescriptor = {
	scheduleDiff: {
		migrationStrategies: {
			1: function (oldDoc: any) {
				// migration to rxdb 12
				return oldDoc;
			},
			2: function (oldDoc: any) {
				// Add note field for driver notices
				oldDoc.note = null;
				return oldDoc;
			},
			3: function (oldDoc: any) {
				/**
				 * New fields added:
				 *  * enteringBookingLegs
				 *  * exitingBookingLegs
				 * */
				oldDoc.note = null;
				return oldDoc;
			},
			4: function (oldDoc: any) {
				/**
				 * New fields added:
				 *  * estimatedStart
				 *  * estimatedEnd
				 *  * consideredDelayed
				 * */
				return oldDoc;
			},
		},
		schema: scheduleDiffSchema,
	},
};
